import Styles from './styles.module.css';
import Logo from './../../../image/home/logo_white.png';
import Instagram from './../../../image/home/footer/instagram.png';
import Tiktok from './../../../image/home/footer/tiktok.png';

const Home = () => {

  return (
    <>
    <div className={Styles.download}>
      <div className={Styles.contents}>
        <div className={Styles.contents_left}>
          <img src={Logo} />
          <div>
            <h5>株式会社memorii</h5>
            <p>
              〒220-0072<br />
              神奈川県横浜市西区浅間町<br />
              1丁目4番3号 ウィザードビル402
            </p>
          </div>
        </div>
        <div className={Styles.contents_right}>
          <div className={Styles.contents_right_text}>
            <a href="https://memorii-works.com/">
              <p>ホーム</p>
            </a>
            <a href="https://apps.apple.com/jp/app/memorii-works/id1578278781" target="_blank" rel="noopener noreferrer">
              <p>就活アプリ</p>
            </a>
            <a href="https://memorii-works.com/company/login">
              <p>ログイン</p>
            </a>
            <a href="https://memorii-works.com/contact">
              <p>お問合わせ</p>
            </a>
            <a href="https://memorii-works.com/about">
              <p>運営会社</p>
            </a>
          </div>
          <div className={Styles.contents_right_text}>
            <a href="https://memorii-works.com/terms-Service">
              <p>利用規約</p>
            </a>
            <a href="https://memorii-works.com/policy-service">
              <p>プライバシーポリシー</p>
            </a>
          </div>
          <div className={Styles.contents_right_logo}>
            <a href="https://www.instagram.com/memorii.photo/" target="_blank" rel="noopener noreferrer">
              <img src={Instagram} />
            </a>
            <a href="https://www.tiktok.com/@memorii.photo" target="_blank" rel="noopener noreferrer">
              <img src={Tiktok} />
            </a>
          </div>
        </div>
      </div>
      <div className={Styles.hr}></div>
      <p>© 2026 memorii, Inc. All Rights Reserved.</p>
    </div>
    </>
  );
}


export default Home;